const NS = 'CampaignSiteHeader';
const CLS = 'campaignSiteHeader';

export class CampaignSiteHeader {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.init();
	}

	init() {
		$('.hasnav').each((i, el) => {
			let navid = $(el).data('nav');
			$(el).on('click', () => {
				this.openNav(navid);
			});
		});

		$('.sidenav-back').each((i, el) => {
			let navid = $(el).data('nav');
			$(el).on('click', () => {
				this.closeNav(navid);
			});
		});

		$('.closebtn').on('click', () => {
			$('.campaignSiteHeader-sidenav').css('left', '-100%');
			$('.campaignSiteHeader-top').removeClass('fix');
		});

		// $('.campaignSiteHeader-search-pc .search-btn').on('click', () => {
		// 	$('.campaignSiteHeader-search-pc input').removeClass('d-none');
		// 	$('.campaignSiteHeader-search-pc input').focus();
		// 	$('.campaignSiteHeader-search-pc .search-btn').addClass('d-none');
		// });

		$('.campaignSiteHeader-language').on('click', (e) => {
			$('.campaignSiteHeader-language').toggleClass('active inactive');
		});

		window.onscroll = () => {
			this.campaignSiteHeaderScroll();
		};

		this.scrollTrigger();

		this.$element.find('a.accordion-head-title').on('click', () => {
			$('.campaignSiteHeader-sidenav').css('left', '-100%');
			$('.campaignSiteHeader-top').removeClass('fix');
		});
		// this.handleLanguageModal();
	}

	// handleLanguageModal () {
	// 	if($("#caldLanguageModalTriggerBtn").length) {
	// 		$(".campaignSiteHeader-language-list  a").on("click", function(event) {
	// 			event.preventDefault();

	// 			const url = $(this).attr('href')
	// 			const modalBtn = $('#caldLanguageModal .caldLanguageModal-btn[data-action="redirect"]');

	// 			modalBtn.length && modalBtn.attr("href", url);
	// 			$("#caldLanguageModalTriggerBtn").trigger("click")
	// 		})
	// 	}
	// }

	openNav(navid) {
		document.getElementById(navid).style.left = '0%';
		$('.campaignSiteHeader-top').addClass('fix');
	}

	closeNav(navid) {
		document.getElementById(navid).style.left = '-100%';
	}

	campaignSiteHeaderScroll() {
		var header = document.getElementById('campaignSiteHeader-sticky');
		var sticky = header.offsetTop;

		if (window.pageYOffset > sticky) {
			header.classList.add("sticky");
			$('main').addClass('scrollPadding');
		} else {
			header.classList.remove("sticky");
			$('main').removeClass('scrollPadding');
		}
	}

	scrollTrigger() {
		$('.nav-item a').on('click', (e) => {
			console.log(e.currentTarget);
			e.preventDefault();
			let id = $(e.currentTarget).attr('href');
			let $el = $(`${id}`);
			console.log($el);

			$('html,body').animate({
				scrollTop: $el.offset().top - 170
			}, 0);
		});
	}
}
